import React from 'react';

/** First thing in the DOM; visible only when focused. Target is <main id="main" tabIndex={-1}>. */
export default function SkipLink() {
  return (
    <a href="#main" className="mk-skip t-details">
      Skip to content
    </a>
  );
}
